import React, {useState} from 'react';
import {IonSegment, IonSegmentButton} from '@ionic/react';
import ColorDeclarationCreateNewCard from '../components/ColorDeclarationPage/ColorDeclarationCreateNewCard';
import ColorDeclarationCreatedCard from '../components/ColorDeclarationPage/ColorDeclarationCreatedCard';

const ColorDeclarationPage: React.FC = () => {
  const [tabValue, setTabValue] = useState('ny');
  const newTabValue = (value: string) => {
    setTabValue(value);
  };

  return (
    <div className='flex flex-col md:flex-row md:space-x-6 w-full h-full md:py-6 md:pr-6 bg-white'>
      <IonSegment mode='md' onIonChange={(e) => e.detail.value && newTabValue(e.detail.value)} value={tabValue}
        className='md:hidden w-full mt-5 border-b-2 border-neutral-100'>
        <IonSegmentButton value='ny' className='normal-case
         text-lg font-Outfit text-navy-primary w-1/2'>Ny</IonSegmentButton>
        <IonSegmentButton value='sparade' className='normal-case text-lg
         font-Outfit text-navy-primary w-1/2'>Sparade</IonSegmentButton>
      </IonSegment>
      <div className={`${tabValue === 'ny' ? 'flex' : 'hidden'} md:flex h-full w-full`}>
        <ColorDeclarationCreateNewCard />
      </div>
      <div className={`${tabValue === 'sparade' ? 'flex' : 'hidden'} md:flex w-full px-5 h-full`}>
        <ColorDeclarationCreatedCard/>
      </div>
    </div>
  );
};

export default ColorDeclarationPage;
